import React, { useState } from 'react';
import {
  Typography,
  Box,
  Alert,
  Switch,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon
} from '@mui/icons-material';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebase/config';

const VisibilitySection = ({ userProfile, expandedSection, onAccordionChange, setSuccess, setError, currentUser, isMobile }) => {
  const [isPublic, setIsPublic] = useState(userProfile.isPublic !== false);

  const handleVisibilityChange = async (event) => {
    const newVisibility = event.target.checked;
    setIsPublic(newVisibility);

    try {
      const userRef = doc(db, 'users', currentUser.uid);
      await updateDoc(userRef, {
        isPublic: newVisibility,
        updatedAt: new Date()
      });

      setSuccess(newVisibility ? 'Votre salon est maintenant visible publiquement' : 'Votre salon est maintenant masqué du public');
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Error updating visibility:', error);
      setError('Erreur lors de la mise à jour de la visibilité');
      setIsPublic(!newVisibility);
    }
  };

  const colors = {
    primary: '#000000',
    secondary: '#6B7280',
    accent: '#F5F5DC',
    background: '#F8F9FA',
    surface: '#FFFFFF',
    border: '#E5E7EB'
  };

  const content = (
    <Box sx={{ p: { xs: 0.5, sm: 1, md: 4 } }}>
      {!isMobile && (
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: colors.primary,
            mb: { xs: 2, md: 3 },
            fontSize: { xs: '1.125rem', md: '1.25rem' }
          }}
        >
          Visibilité du salon
        </Typography>
      )}

      <Typography
        variant="body2"
        sx={{
          color: colors.secondary,
          mb: { xs: 2, md: 3 },
          lineHeight: 1.6,
          fontSize: { xs: '0.875rem', md: '1rem' }
        }}
      >
        Contrôlez si votre salon apparaît dans les résultats de recherche publics
      </Typography>

      <FormControlLabel
        control={
          <Switch
            checked={isPublic}
            onChange={handleVisibilityChange}
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': {
                color: colors.primary,
              },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                backgroundColor: colors.primary,
              },
            }}
          />
        }
        label={
          <Typography sx={{ 
            fontSize: { xs: '0.875rem', md: '1rem' },
            fontWeight: 500,
            color: colors.primary
          }}>
            {isPublic ? "Salon visible publiquement" : "Salon masqué du public"}
          </Typography>
        }
        sx={{ mb: 2 }}
      />

      {!isPublic && (
        <Alert 
          severity="info" 
          sx={{ 
            borderRadius: 2,
            '& .MuiAlert-message': {
              fontSize: { xs: '0.875rem', md: '1rem' }
            }
          }}
        >
          Votre salon est actuellement masqué des résultats de recherche. Seuls les clients ayant votre lien direct peuvent voir votre fiche.
        </Alert>
      )}
    </Box>
  );

  if (isMobile) {
    return (
      <Accordion 
        expanded={expandedSection === 'visibility'} 
        onChange={onAccordionChange('visibility')}
        elevation={0}
        sx={{ 
          '&:before': { display: 'none' },
          borderRadius: '0 !important'
        }}
      >
        <AccordionSummary 
          expandIcon={<ExpandMoreIcon />}
          sx={{
            px: { xs: 0.5, sm: 1, md: 3 },
            py: { xs: 1, md: 2 },
            minHeight: 'auto',
            '&.Mui-expanded': {
              minHeight: 'auto'
            },
            '& .MuiAccordionSummary-content': {
              margin: 0,
              '&.Mui-expanded': {
                margin: 0
              }
            }
          }}
        >
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 600,
              color: colors.primary,
              fontSize: '1.125rem'
            }}
          >
            Visibilité du salon
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 0 }}>
          {content}
        </AccordionDetails>
      </Accordion>
    );
  }

  return content;
};

export default VisibilitySection;